module.exports = __webpack_public_path__ + "img/popup_download_applestore.bc2e8c43.png";